<script setup>
import { getCurrentInstance } from 'vue';
import DashboardWelcome from './DashboardWelcome';
import DashboardStateHistory from './DashboardStateHistory';
import DashboardActivityStream from './DashboardActivityStream';

const { proxy } = getCurrentInstance();

// --- Lifecycle ---

/**
 * Equivalent to created().
 * We reset the navigation component selection when landing on the dashboard.
 */
proxy.$store.commit('navigationComponent', false);
</script>

<template>
    <div class="container-fluid dashboard">
        <h1 class="h4 my-4">Dashboard</h1>

        <div class="row">
            <div class="col-sm-6">
                <DashboardWelcome/>
                <DashboardStateHistory/>
            </div>

            <div class="col-sm-6">
                <DashboardActivityStream/>
            </div>
        </div>
    </div>
</template>

<style>
/* Note: Keeping these styles global as in the original,
   allowing them to affect the child components within the .dashboard container.
*/
.dashboard .card {
    border-top: 4px solid #00d7b2;
}

.dashboard .card-header {
    padding: 15px;
    border: none;
    background: none;
}

.dashboard-panel-state-history .card-body {
    padding-top: 0;
    height: 255px;
    overflow: scroll;
}
</style>